<div class="p-text-right dark-bg" *ngIf="showBanner">
  <i class="pi pi-times cursor-pointer p-mr-2" (click)="showBanner = false"></i>
  <div class="p-grid">
    <div class="p-col-10 p-text-left">
      <p class="p-mt-0">Utilizamos cookies propias y de terceros para obtener datos estadísticos de la navegación de nuestros usuarios
        y
        mejorar nuestros servicios. Si acepta o continúa navegando, consideramos que acepta su uso. Puede cambiar la
        configuración u obtener más información <a href="https://calculadora.supervecina.com/#/cookiepolicy"
          target="_blank">aquí</a></p>
    </div>
    <div class="p-col-2">
      <div class="p-col-6">
        <button pButton pRipple type="button" (click)="showBanner = false" label="Acepto"
          class="p-button-warning"></button>
      </div>
    </div>
  </div>
